import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
   Site, UserData,
} from "../../model/model";

import UserForm from "./UserForm";
import SessionStore from "../../model/SessionStore";

function CreateSiteUser({ site }: { site: Site }) {
  const navigate = useNavigate();

  const onFinish = (obj: UserData) => {
    obj.siteId = site.id;

    SessionStore.getClient().createUser(obj, SessionStore.getBearer()).then( () => {
      navigate(`/site/${site.id}/users`);
    });
  };

  const userData :UserData= {
      login: '',
          email: '',
          name: '',
          role: '',
          pass: '',
          subId: site.subId,
          orgId: site.orgId,
          siteId: site.id,
          lastSeenAt:0
    };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Sites</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to={`/site/${site.id}/dash`}>{site.name}</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to={`/site/${site.id}/users`}>Site devices</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Add</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Add site device"
      />
      <Card>
        <UserForm initialValues={userData} onFinish={onFinish} password = {true}/>
      </Card>
    </Space>
  );
}

export default CreateSiteUser;
